import React from 'react';

import { TableCell, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { HORIZONTAL_ALIGNMENT } from 'constants/ui';

const SummaryTableCell = ({ children = null, align = HORIZONTAL_ALIGNMENT.LEFT, className }) => {
  return (
    <TableCell align={align} className={className}>
      <Typography color="text.primary" variant="bold14">
        {children}
      </Typography>
    </TableCell>
  );
};

SummaryTableCell.propTypes = {
  children: PropTypes.node.isRequired,
  align: PropTypes.string,
  className: PropTypes.string,
};

export default SummaryTableCell;
